module.exports = __webpack_public_path__ + "static/media/downArrow.ba2b4e11.svg";